<template>
  <div
    class="c_flex c_cursor"
    @click="visible = true"
  >
    <span>任务中心</span>
  </div>
  <app-task-center
    v-model="visible"
    :authorization="authorization"
    :headers="{
      'Accept-language': handleGetLanguage(),
    }"
  />
</template>

<script lang="ts" setup>
import { onBeforeMount, ref } from 'vue'
import { useCommon } from '@y/composables'

const {
  fns: { handleGetToken, handleGetLanguage },
} = useCommon()

const visible = ref(false)
const authorization = ref('')

onBeforeMount(() => {
  authorization.value = handleGetToken()
})
</script>
